export default "__VITE_ASSET__DD6A1uMB__"